import { accessRole } from "../../../../helpers/access_role";
import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import { FileInput1 } from "../../../../helpers/ui/FileInput1";

import Select from "../../../../helpers/ui/CustomSelect";
import CustomSelect from "../../../../helpers/ui/CustomSelect"
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import moment from "moment";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";

import CreateBloc from "./Blocs/CreateBloc";

class IndexView extends Component {
  createBloc = new CreateBloc();
  timer;

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      employeeOptions: [],
      positionOptions: [],
      optcriteria: [],
      monthOptions: this.createMonthOptions(),
      yearOptions: this.createYearOption(new Date().getFullYear() - 30),
      month: localStorage.getItem(this.historyMonth)
        ? JSON.parse(localStorage.getItem(this.historyMonth))
        : moment().format("M"),
      year: localStorage.getItem(this.historyYear)
        ? JSON.parse(localStorage.getItem(this.historyYear))
        : moment().format("YYYY"),
      is_pltplh: null,
      position_name: '',
      hasilperilakuOption: [
        { 'label': 'Di atas', 'value': 'Di atas' },
        { 'label': 'Sesuai', 'value': 'Sesuai' },
        { 'label': 'Di bawah', 'value': 'Di bawah' },
      ]
    };
  }

  createMonthOptions() {
    var months = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];

    return months.map(function (month, i) {
      var newObj = {};
      newObj["label"] = month;
      newObj["value"] = ++i;

      return newObj;
    });
  }
  createYearOption(startYear = 2000) {
    var currentYear = new Date().getFullYear(),
      years = [];
    startYear = startYear || 1980;
    while (startYear <= currentYear) {
      var newObj = {};
      var year = startYear++;
      newObj["label"] = year;
      newObj["value"] = year;
      years.push(newObj);
    }
    return years;
  }

  convertToFormData(data) {
    const formData = new FormData();

    for (const key in data) {
      const value = data[key];
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (Array.isArray(item)) {
              item.forEach((itm, idx) => {
                if (itm !== null && itm !== undefined) {
                  formData.append(`${key}[${index}][]`, itm);
                }
              });
            } else {
              formData.append(`${key}[]`, item);
            }
          });
        } else {
          formData.append(key, value);
        }
      }
    }

    return formData;
  }

  reformatOptionsEmployee = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data['employee_nip'] + ' - ' + data[label];
      newObj["value"] = data[value];
      newObj["model"] = data;

      return newObj;
    });
  };

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
      newObj["model"] = data;

      return newObj;
    });
  };

  submitData = async () => {
    // await this.createBloc.fetchCreatepernip(
    //   this.convertToFormData(this.state.dataForm)
    // );
    const formData = generateFormData(this.state.dataForm, 'file_doc') // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 

    await this.createBloc.fetchCreatepernip(formData)
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };
  getposition = (nip) => {
    this.createBloc.fetchPosition({ month: this.state.month, year: this.state.year, nip: nip })
  }
  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.employeeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response
            // console.log(response)
            this.setState({
              employeeOptions: this.reformatOptionsEmployee(
                response.result,
                'employee_full_name',
                'employee_nip',
              ),
              isLoadingOptEmployee: false
            })
          }
          break
        case apiResponse.ERROR:

          break
        default:
          break
      }
    })
    this.createBloc.fetchEmployee()

    this.createBloc.positionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response
            // console.log(response)
            this.setState({
              positionOptions: this.reformatOptions(
                response.result,
                'employee_current_position_name',
                'is_pltplh',
              ),
              isLoadingOptEmployee: false
            })
          }
          break
        case apiResponse.ERROR:

          break
        default:
          break
      }
    })


    this.createBloc.individualCriteriaChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response
            // console.log(response)
            this.setState({
              optcriteria: this.reformatOptions(
                response.result,
                'individual_assessment_criteria_name',
                'individual_assessment_criteria_name',
              ),
              isLoadingOptEmployee: false
            })
            console.log(this.state.optcriteria);
          }
          break
        case apiResponse.ERROR:

          break
        default:
          break
      }
    })
    this.createBloc.fetchIndividualCriteria()
  }

  componentWillUnmount() {
    this.createBloc.createChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div className="float-end">
                    <Link
                      to={`?`}
                    >
                      <Button outline color="primary">
                        <i className="uil uil-backward"></i> Kembali
                      </Button>
                    </Link>
                  </div>
                  <CardTitle>Tambah Laporan Penilaian SKP</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    {/* <Row className="mb-3">
                      <label
                        htmlFor="special_allowance_summary_year"
                        className="col-md-3 col-form-label"
                      >
                        Tahun SKP <span className="text-danger">*</span>
                      </label>
                      <Col md="6">
                        <AvField
                          name="special_allowance_summary_year"
                          placeholder="Tahun SKP..."
                          type="text"
                          errorMessage="Masukkan Tahun SKP"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="special_allowance_summary_year"
                        />
                      </Col>
                    </Row> */}
                    <Row className="mb-3">
                      <label
                        htmlFor="no_skx"
                        className="col-md-3 col-form-label"
                      >
                        Bulan <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="period_month"
                          errorMessage="Pilih Bulan"
                          options={this.state.monthOptions}
                          placeholder="Pilih Bulan"
                          defaultValue={this.state.month}
                          onChange={(v) => this.setState({ month: v.value })}
                          isAvForm={false}
                        />

                        <AvField
                          name="month"
                          type="hidden"
                          id="month"
                          value={this.state.month}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_skx"
                        className="col-md-3 col-form-label"
                      >
                        Tahun <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="period_year"
                          errorMessage="Pilih Tahun"
                          options={this.state.yearOptions}
                          placeholder="Pilih Tahun"
                          defaultValue={this.state.year}
                          onChange={(v) => this.setState({ year: v.value })}
                          isAvForm={false}
                        />

                        <AvField
                          name="year"
                          type="hidden"
                          id="month"
                          value={this.state.year}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="nip"
                        className="col-md-3 col-form-label"
                      >
                        Pegawai <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name={`nip`}
                          errorMessage="Pilih Pegawai"
                          options={this.state.employeeOptions}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Pegawai"
                          // isLoading={this.state.isLoadingOptEmployee}
                          onChange={(v) => {
                            this.setState({
                              selecttedNIP: v.value,
                              positionOptions: []
                            })
                            this.getposition(v.value)
                          }}
                        // defaultValue={data.type}
                        />
                        <AvField
                          name="nip"
                          type="hidden"
                          id="nip"
                          value={this.state.selectedNIP}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="nip"
                        className="col-md-3 col-form-label"
                      >
                        Jabatan <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name={`is_pltplh`}
                          errorMessage="Pilih Jabatan"
                          options={this.state.positionOptions}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Jabatan"
                          // isLoading={this.state.isLoadingOptEmployee}
                          onChange={
                            (v) => this.setState({
                              is_pltplh: v.value,
                              position_name: v.label,
                            })
                          }
                        // defaultValue={data.type}
                        //test
                        />
                        <AvField
                          name="is_pltplh"
                          type="hidden"
                          id="is_pltplh"
                          value={this.state.is_pltplh}
                        />
                        <AvField
                          name="position_name"
                          type="hidden"
                          id="position_name"
                          value={this.state.position_name}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="hasilkerja"
                        className="col-md-3 col-form-label"
                      >
                        Hasil Kerja <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        {/* <AvField 
                                name={`hasilkerja`}
                                type="text"
                                errorMessage="Penilaian Harus diisi"
                                // options={this.state.optcriteria} 
                                validate={{ required: { value: true } }}
                                placeholder="Penilaian"
                                // isLoading={this.state.isLoadingOptEmployee}
                                // onChange={
                                //     (v) => this.setState({
                                //         hasilkerja: v.value
                                //     })
                                // }
                                // defaultValue={data.type}
                            /> */}
                        <CustomSelect
                          name={`hasilkerja`}
                          errorMessage="Pilih Penilaian"
                          options={this.state.hasilperilakuOption}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Penilaian"
                          isLoading={this.state.hasilperilakuOption}
                        // onChange={
                        //     (v) => this.setState({
                        //         selectedEmployee: v.model
                        //     })
                        // }
                        // defaultValue={data.type}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="perilakukerja"
                        className="col-md-3 col-form-label"
                      >
                        Perilaku Kerja <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        {/* <AvField 
                                name={`perilakukerja`}
                                type="text"
                                errorMessage="Penilaian Harus diisi"
                                // options={this.state.optcriteria} 
                                validate={{ required: { value: true } }}
                                placeholder="Penilaian"
                                // isLoading={this.state.optcriteria}
                                // onChange={
                                //     (v) => this.setState({
                                //         selectedEmployee: v.model
                                //     })
                                // }
                                // defaultValue={data.type}
                            /> */}
                        <CustomSelect
                          name={`perilakukerja`}
                          errorMessage="Pilih Penilaian"
                          options={this.state.hasilperilakuOption}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Penilaian"
                          isLoading={this.state.hasilperilakuOption}
                        // onChange={
                        //     (v) => this.setState({
                        //         selectedEmployee: v.model
                        //     })
                        // }
                        // defaultValue={data.type}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="hasilakhir"
                        className="col-md-3 col-form-label"
                      >
                        Hasil Akhir <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name={`hasilakhir`}
                          errorMessage="Pilih Penilaian"
                          options={this.state.optcriteria}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Penilaian"
                          isLoading={this.state.optcriteria}
                        // onChange={
                        //     (v) => this.setState({
                        //         selectedEmployee: v.model
                        //     })
                        // }
                        // defaultValue={data.type}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Upload Dok SKP
                      </label>
                      <Col md="6">
                        <FileInput
                          name="file_doc"
                          accept=".pdf"
                          validate={{ required: { value: false } }}
                          maxFiles={1}
                          isMultiple={false}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="?">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/skp_tunjangan_khusus.html" />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
// aaaaaaaaaaaaaaaaaaaaaa
